export function identify(userId) {
  const dummyValue = "dummy_user_value"

  const userData = {
    id: userId,
    email: dummyValue,
    firstName: dummyValue,
    lastName: dummyValue
  }

  window.aptrinsic("identify", userData)
}

export function track(event, properties) {
  if (!window.aptrinsic) {
    return
  }

  window.aptrinsic("track", event, properties)
}
